import { isEmpty, concat, get } from 'lodash'
import { TECHNO_CATEGORIES } from '@/utils/constants'
import commonActions from '@/store/data/common/actions'
import { errorHandler } from '@/utils/helpers'
import { webRequestClient } from '@/services'
import helpers from './helpers'

const actions = {
    retrieveItems({ commit, rootState }) {
        //check if techno data is active for this user, if not, don't fetch it
        const dataType = get(rootState.data.settings.sociodemo, 'technology', null)
        if (!dataType) return

        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(rootState.account)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(browser => {
                if (get(browser, 'status', '') === 'KO') {
                    errorHandler('Error while retrieving browsers', commit)
                } else if (!isEmpty(browser.list)) {
                    const countryCode2 = get(rootState, 'account.country.code2', '')
                    commit('setRetrievedItems', {
                        items: concat(TECHNO_CATEGORIES.browser, helpers.parseData(browser.list, countryCode2))
                    })
                    commit('setCollection', helpers.instanciateAll(browser.list, countryCode2))
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
